import React from 'react';

const DISCChart = ({ scores, title, showLabels = true, size = 'medium' }) => {
  const maxScore = 100;

  const sizeConfig = {
    small: { containerHeight: 128, barWidth: 32, fontSize: 12 },
    medium: { containerHeight: 192, barWidth: 48, fontSize: 14 },
    large: { containerHeight: 256, barWidth: 64, fontSize: 16 },
  };

  const colors = {
    D: { bg: '#DC2626', text: '#DC2626' }, // red-600
    I: { bg: '#F58820', text: '#F58820' }, // tsvmap-orange
    S: { bg: '#2563EB', text: '#2563EB' }, // blue-600
    C: { bg: '#EAB308', text: '#EAB308' }, // yellow-500
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  const bars = [
    { key: 'D', value: scores?.D || 0, label: 'D' },
    { key: 'I', value: scores?.I || 0, label: 'I' },
    { key: 'S', value: scores?.S || 0, label: 'S' },
    { key: 'C', value: scores?.C || 0, label: 'C' },
  ];

  return (
    <div className="flex flex-col items-center">
      {title && (
        <h3
          className="font-semibold text-gray-700 mb-4"
          style={{ fontSize: config.fontSize }}
        >
          {title}
        </h3>
      )}

      {/* Chart container */}
      <div
        className="flex items-end justify-center gap-3 border-b-2 border-gray-300 pb-1"
        style={{ height: config.containerHeight }}
      >
        {bars.map((bar) => {
          const barHeight = (bar.value / maxScore) * config.containerHeight;
          return (
            <div key={bar.key} className="flex flex-col items-center justify-end h-full">
              <div
                className="rounded-t transition-all duration-500"
                style={{
                  width: config.barWidth,
                  height: Math.max(barHeight, 4), // minimum height of 4px
                  backgroundColor: colors[bar.key].bg,
                }}
              />
            </div>
          );
        })}
      </div>

      {/* Labels */}
      {showLabels && (
        <div className="flex justify-center gap-3 mt-3">
          {bars.map((bar) => (
            <div
              key={bar.key}
              className="text-center"
              style={{ width: config.barWidth }}
            >
              <span
                className="font-bold block"
                style={{ color: colors[bar.key].text, fontSize: config.fontSize }}
              >
                {bar.label}
              </span>
              <span
                className="text-gray-600 block"
                style={{ fontSize: config.fontSize - 2 }}
              >
                {bar.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DISCChart;
